import { render, staticRenderFns } from "./BrokeredSettlementPrint.vue?vue&type=template&id=ef02dcd8&scoped=true&"
import script from "./BrokeredSettlementPrint.vue?vue&type=script&lang=js&"
export * from "./BrokeredSettlementPrint.vue?vue&type=script&lang=js&"
import style0 from "./BrokeredSettlementPrint.vue?vue&type=style&index=0&id=ef02dcd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef02dcd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCol,VDivider,VImg,VRow,VSimpleTable,VSubheader})
